import React, {useState} from 'react';
//External
import {
    Button, Card, CardBody, CardHeader, Collapse,
    Input,
} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleCheck, faClock, faEnvelope} from "@fortawesome/free-regular-svg-icons";
import {faPencil} from "@fortawesome/free-solid-svg-icons/faPencil";
import requestApi from "../../../services/requestApi.service";
import {decodeString, randstr, showToast,handleErrorResponse} from "../../../Common/Appcommon";
import QuickReplyOperations from "../../QuickReply/QuickReplyOperations";
import {faCircleExclamation, faPlus} from "@fortawesome/free-solid-svg-icons";
import CratioTooltip from "../../../Common/CratioTooltip";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import Select from "react-select";
import {faHourglass} from "@fortawesome/free-solid-svg-icons/faHourglass";
import { useForm } from 'react-hook-form';

const InboxSettingsItem = props => {
    let {settings} = props;
    let id = settings['id'];
    let name = settings['title'];
    let desc = settings['description'];
    let status = settings['status'];
    let responseType = settings['response_type'];
    let delayedHr = settings['delayed_hr'];
    let delayedMin = settings['delayed_min'];
    let defaultHr = {label : 0, value : 0};
    let defaultMin = {label : 5, value : 5};
    if(delayedHr !== null && delayedHr !== ""){
        defaultHr = {label : delayedHr, value : delayedHr};
    }
    if(delayedMin !== null && delayedMin !== ""){
        defaultMin = {label : delayedMin, value : delayedMin};
    }
    let messageId = settings['message_id'];
    const [selectedID, setSelectedID] = useState("");
    const [statusText, setStatusText] = useState(status);
    const [isMessageModalEnabled, showMessageModal] = useState(false);
    let messageTxt = settings['Body'] !== null ? decodeString(settings['Body'],true) : "";
    let isInteractiveMsg = settings['ia_message_id'] !== null && settings['ia_message_id'] !== "";
    const [messageText, setMessageText] = useState(messageTxt);
    const [delayedHour, setDelayedHour] = useState(defaultHr);
    const [delayedMinute, setDelayedMinute] = useState(defaultMin);
    const [replyTempId, setReplyTemplateId] = useState();
    //setStatusText(status);
    const toggleInboxSettings = (id) => {
        if(selectedID === id){
            setSelectedID("");
        } else {
            setSelectedID(id);
        }
    }

    const changeInboxSettingsStatus = async (id, status, title) => {
        let newStatus = status.toLowerCase() === "enabled" ? "Disabled" : "Enabled";
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "UPDATE_IB_SETTINGS",
            "SETTINGS": "IB_STATUS",
            "STATUS" : newStatus,
            "ID" : id
        };

        let response = await requestApi.processServerRequest(params, "WebV2", "post");
        if(response.issuccess){
            setStatusText(newStatus);
            showToast(title+" is "+newStatus);
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const editReplyMessage = () => {
        setReplyTemplateId(messageId);
        showMessageModal(!isMessageModalEnabled);
    }

    const onReplyMessageSave = async (isModalEnabled, messageId) => {
        showMessageModal(isModalEnabled);
        if(messageId !== "" && messageId !== undefined) {
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "UPDATE_IB_SETTINGS",
                "SETTINGS": "UPDATE_REPLY",
                "ID": id,
                "MESSAGE_ID": messageId,
            };

            let response = await requestApi.processServerRequest(params, "WebV2", "post");
            if (response.issuccess) {
                messageTxt = response.data;
                if (messageTxt !== "") {
                    messageTxt = decodeString(messageTxt,true);
                }
                setReplyTemplateId(messageId);
                setMessageText(messageTxt);
            }else{
                handleErrorResponse(response.errormsg);
            }
        }
    }

    const onDelayTimingChange = async (selectedTime, objName) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "UPDATE_IB_SETTINGS",
            "SETTINGS": "UPDATE_DELAY",
            "ID" : id,
            "Time" : selectedTime.value,
            "field" : objName
        };

        let response = await requestApi.processServerRequest(params, "WebV2", "post");
        if(response.issuccess){
            let defaultTime = {label: selectedTime.value, value : selectedTime.value};
            if(objName === "delayed_hr"){
                setDelayedHour(defaultTime);
            } else if (objName === "delayed_min"){
                setDelayedMinute(defaultTime);
            }
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    let hourOptions = [];
    for(let hi = 0; hi < 24; hi++){
        hourOptions.push({label: hi, value : hi});
    }
    let minOptions = [];
    minOptions.push({label: 5, value : 5});
    minOptions.push({label: 10, value : 10});
    minOptions.push({label: 15, value : 15});
    minOptions.push({label: 20, value : 20});
    minOptions.push({label: 25, value : 25});
    minOptions.push({label: 30, value : 30});
    minOptions.push({label: 35, value : 35});
    minOptions.push({label: 40, value : 40});
    minOptions.push({label: 45, value : 45});
    minOptions.push({label: 50, value : 50});
    minOptions.push({label: 55, value : 55});
    const form = useForm();
    return (
        <div className={'mb-3 settings-container'}>
            <Card>
                <CardHeader className={'inbox-card'} id={`inbox-settings-${id}`}>
                    <div color="" className="text-start m-0 p-0" onClick={() => toggleInboxSettings(id)}
                            aria-expanded={selectedID === id} aria-controls={`inbox-data-${id}`}>
                        <div className={'header-title'}>
                        <div className={'title-info'}>
                            <h5 className="title-text m-0 p-0">{name}</h5>
                            <p className={'header-desc pt-2'}>{desc}</p>
                        </div>
                        <div className={'status-indicator'}>
                            <p className={statusText.toLowerCase()}>{statusText.toLowerCase() === "enabled" ? "Enabled" : "Disabled"}</p>
                        </div>
                        </div>
                    </div>
                </CardHeader>
                <Collapse isOpen={selectedID === id} className={'settings-content'} data-parent="#accordion" id={`inbox-data-${id}`}>
                    <CardBody>
                        <div>
                            <div className={'reply-message-modal'}>
                                {replyTempId !== undefined && replyTempId !== '' &&
                                    <QuickReplyOperations
                                        key={randstr('quickrep_')}
                                        showActionModal={isMessageModalEnabled}
                                        quickReplyId={replyTempId}
                                        toggleActionsModal={onReplyMessageSave}
                                        type={"inboxSettings"}
                                        useForm={form}
                                    />
                                }
                            </div>
                            <div className={'content-header'}>
                                {responseType === "Delayed" &&
                                <div className={'delayed-setup'}>
                                    <div className={'d-flex-alone'}>
                                        <span className={'timer'}>
                                            <div className={'timer-icon'}>
                                            <FontAwesomeIcon icon={faHourglass} />
                                            </div>
                                        </span>
                                        <span className={'inbox-title'}>
                                            Delayed Response Time
                                        </span>
                                        <span className={'editor'}>
                                            <CratioTooltip id={'132'} title={"The time entered here cannot be null and is mandatory for Delay message to be enabled."} content={
													<FontAwesomeIcon className={'edit-icon'} icon={faCircleInfo}/>} />
                                        </span>
                                    </div>
                                    <div className={'delay-time-info'}>
                                        <div className={'d-flex-alone'}>
                                            <Select onChange={(e) => onDelayTimingChange(e, "delayed_hr")} value={delayedHour} options={hourOptions} className={`basic-multi-select `} classNamePrefix="wa-select" />
                                            <div className={'timing-to'}>Hrs</div>
                                            <Select onChange={(e) => onDelayTimingChange(e,"delayed_min")} value={delayedMinute} options={minOptions} className={`basic-multi-select `} classNamePrefix="wa-select" />
                                            <div className={'timing-to'}>Mins</div>

                                        </div>
                                    </div>
                                </div>
                                }

                                <div className={'inbox-timing-setup'}>
                                    <div className={'d-flex-alone cursor-pointer'}  onClick={(e) => {editReplyMessage()}}>
                                        <span className={'timer'}>
                                            <div className={'timer-icon'}>
                                            <FontAwesomeIcon icon={faEnvelope} />
                                            </div>
                                        </span>
                                        <span className={'inbox-title'}>
                                            {name}
                                        </span>
                                        <span className={'editor'}>
                                            <div className={'edit-icon cursor-pointer'}>
                                            <FontAwesomeIcon icon={faPencil} />
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className={'content-data content-preview'}>
                                <span className="message-content" dir="auto">
                                    <div dangerouslySetInnerHTML={{ __html: messageText }} />
                                </span>
                                {isInteractiveMsg && <div className={'default-bold-font mt-3'}><FontAwesomeIcon icon={faCircleCheck} className={`green-tick`}/> List Messages/ Button Reply Enabled</div>}
                                <div className={'ib-settings-button-panel'}>
                                    <Button onClick={() => changeInboxSettingsStatus(id, statusText, name)} color={statusText.toLowerCase() === "enabled" ? "danger" : "success"} size="lg" className="mt-4">
                                        {statusText.toLowerCase() === "enabled" ? "Disable" : "Enable"}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Collapse>
            </Card>
        </div>
    )
}
export default InboxSettingsItem;
